import { render } from "./TasksTab.vue?vue&type=template&id=861654a6&scoped=true"
import script from "./TasksTab.vue?vue&type=script&lang=js"
export * from "./TasksTab.vue?vue&type=script&lang=js"

import "./TasksTab.vue?vue&type=style&index=0&id=861654a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861654a6"]])

export default __exports__